import buffUtilities from './buffUtilities.js';

function calculateSkillsTotal(skill, characterData, pointTrackers = []) {
    if (!skill || !characterData) return 0;
    let preACPTotal = getTotalSkillAbilityModifier(skill, characterData) + parseInt(skill.ranks) + parseInt(skill.magic) + parseInt(skill.race_trait) + parseInt(skill.misc) + convertTextToNumber(skill.temp) + (skill.classSkill && parseInt(skill.ranks) >= 1 ? 3 : 0) + convertTextToNumber(characterData.skills.globalModifiers) + buffUtilities.getSkillBuffTotal(skill, characterData, pointTrackers) || 0
    if(skill.ability === 'strength' || skill.ability === 'dexterity') {
        return preACPTotal - Math.abs(parseInt(characterData.skills.armorCheckPenalty))
    }
    return preACPTotal
}

function getTotalSkillAbilityModifier(skill, characterData) {
    if (!skill || !skill.abilityModifiers || !characterData || !characterData.abilities) return 0;
    
    let total = 0;
    for (const ability of ['strength', 'dexterity', 'constitution', 'intelligence', 'wisdom', 'charisma']) {
      if (skill.abilityModifiers[ability] && skill.abilityModifiers[ability].modifies) {
        const modifier = characterData.abilities[ability] ? characterData.abilities[ability].modifiedModifier : 0;
        const multiplier = skill.abilityModifiers[ability].multiplier || 1;
        total += Math.floor(modifier * multiplier);
      }
    }
    return total;
}

function convertTextToNumber(text) {
  if(!text || text.length < 1) text = "";
  const numbers = text.match(/[+-]?\d+/g) || [];
  return numbers.reduce((sum, num) => sum + parseInt(num), 0);
}

function applyRelativeIntegerInput(input, baseline, minimum = Number.NEGATIVE_INFINITY) {
  const text = String(input == null ? '' : input).trim();
  const previous = Number.parseInt(baseline, 10);
  const safeBaseline = Number.isFinite(previous) ? previous : 0;
  if (!/^[+-]?\d+$/.test(text)) return Math.max(minimum, safeBaseline);

  const parsed = Number.parseInt(text, 10);
  const value = /^[+-]/.test(text) ? safeBaseline + parsed : parsed;
  return Math.max(minimum, value);
}

export default {
  calculateSkillsTotal,
  getTotalSkillAbilityModifier,
  convertTextToNumber,
  applyRelativeIntegerInput
}